import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import type { ILoaderData as IStaffLoaderData } from "@pages/panelPages/userManagement/staff/staffForm";
import { useUIStore } from "@/stores/uiStore";

export const myStaffsRoute: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () => import("@pages/panelPages/doctorStaffs/doctorStaffsList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.myStaffAndMsp", [], "index", "main");
        return {};
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.view.route,
      lazy: () => import("@pages/panelPages/doctorStaffs/view/viewStaff"),
      loader: ({ params, request }): IStaffLoaderData => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.staffManagement",
            [{ title: "pageTitle.myStaffList", url: path.list.link() }],
            "view",
          );
        return { mode: "view", id: params.id! };
      },
    },
    permissions: ["doctor"],
  },
];
